/** Internal helper imports here ... */
import { includes, map, replace } from 'lodash';
import moment from 'moment';
import Mustache from 'mustache/mustache.min';
import datepicker from 'js-datepicker';
import ApiModel from '../helpers/apiModel';
import Util from '../helpers/burc_util';

const EVENTS_ID = 'stonorEvents';

class Events {
  constructor(state) {
    this.container = document.querySelector('#stonorEvents');

    if (this.container) {
      this.initialiseState(state);
    }
  }

  initialiseState(state) {
    this.state = {
      weekStart: state.weekStart,
      weekEnd: state.weekEnd,
      selectedCategory: '',
      template: document.getElementById('EventTemplate').innerHTML,
      emptyTemplate: document.getElementById('NoEventsTemplate').innerHTML,
      currentEvents: null,
    };
  }

  async init() {
    this.state.currentEvents = await this.getEvents();
    this.showEvents();
  }

  showEvents() {
    if (!this.state.currentEvents || !this.state.currentEvents.length) {
      this.container.innerHTML = Mustache.render(this.state.emptyTemplate, {
        weekStart: this.state.weekStart,
        weekEnd: this.state.weekEnd
      });
    } else {
      this.container.innerHTML = Mustache.render(this.state.template, {
        events: map(this.state.currentEvents, this.mapEventToTemplate.bind(this)),
      });
    }
  }

  async update(newState) {
    this.state = Object.assign(this.state, newState);

    this.state.currentEvents = await this.getEvents();
    this.clearEvents();
    this.showEvents();
  }

  getEvents() {
    return ApiModel.get('events', {
      week_start: this.state.weekStart,
      week_end: this.state.weekEnd,
      category: this.state.selectedCategory,
    });
  }

  clearEvents() {
    this.container.innerHTML = '';
  }

  mapEventToTemplate(event) {
    const newEvent = event;

    newEvent.title = Util.decodeHtml(event.title);

    if (event.startDate) {
      newEvent.dateString = this.getDateString(event.startDate, event.endDate);
    }

    return newEvent;
  }

  getDateString(startDate, endDate) {
    const mStartDate = moment(startDate, 'DD/MM/YYYY');
    const mEndDate = moment(endDate, 'DD/MM/YYYY');

    let dateString = `${mStartDate.format('ddd MMMM Do')}`;

    if (endDate && !mStartDate.isSame(mEndDate)) {
      if (mStartDate.month() === mEndDate.month()) {
        dateString += ` to ${mEndDate.format('Do')}`;
      } else {
        dateString += ` to ${mEndDate.format('MMMM')} ${mEndDate.format('Do')}`;
      }
    }

    return dateString;
  }
}

const EventTimeframes = {
  PREVIOUS: 'previous',
  NEXT: 'next',
};

/**
 * Module description...
 *
 * @returns {{init: init}}
 */
export default (() => {
  /**
   * Other functions...
   */

  let DOMRoot;
  let event;

  const getLoadingSpinner = () => document.querySelector('.loading');

  const getDataFromDOM = (dataName) => {
    if (!DOMRoot) {
      DOMRoot = document.querySelector(`#${EVENTS_ID}`);
    }

    return DOMRoot.attributes[`data-${dataName}`].value;
  };

  const setLoading = (loading) => {
    if (!DOMRoot) {
      DOMRoot = document.querySelector(`#${EVENTS_ID}`);
    }

    if (loading) {
      DOMRoot.setAttribute('style', `min-height: ${DOMRoot.clientHeight}px`);
      getLoadingSpinner().classList.add('loading--on');
      DOMRoot.classList.add('events__list--loading');
    } else {
      DOMRoot.setAttribute('style', `min-height: 0`);
      getLoadingSpinner().classList.remove('loading--on');
      DOMRoot.classList.remove('events__list--loading');
    }
  };

  const resetWeekText = () => {
    if (document.querySelectorAll('.animText').length > 1) {
      document.querySelector('.animText--out').remove();
      document.querySelector('.animText--in').classList.remove('animText--in', 'animText--new');
    }
  };

  const updateWeekText = (weekStart, weekEnd) => {
    resetWeekText();

    const AnimText = document.querySelector('.animText');

    const dateString = `${weekStart.format('DD')} - ${weekEnd.format('DD')} ${weekEnd.format('MMMM')}`;
    const newText = document.createElement('span');
    AnimText.insertAdjacentElement("afterend", newText);
    newText.classList.add('animText', 'animText--new');
    newText.innerText = dateString;

    setTimeout(() => {
      newText.classList.add('animText--in');
      AnimText.classList.add('animText--out');
    }, 1);
  };

  const changeCategory = async (node) => {
    const category = node.attributes['data-category'].value;

    document.querySelector('.whatsOn__tag--selected').classList.remove('whatsOn__tag--selected');
    node.classList.add('whatsOn__tag--selected');
    setLoading(true);

    await event.update({
      selectedCategory: category,
    });

    setLoading(false);
  };

  const changeWeek = async ({ weekStart, weekEnd }) => {
    DOMRoot.setAttribute('data-week-start', weekStart.format('YYYYMMDD'));
    DOMRoot.setAttribute('data-week-end', weekEnd.format('YYYYMMDD'));

    setLoading(true);
    updateWeekText(weekStart, weekEnd);

    await event.update({
      weekStart: weekStart.format('YYYYMMDD'),
      weekEnd: weekEnd.format('YYYYMMDD'),
    });

    setLoading(false);
  };

  const changeWeekFromTimeframe = (node) => {
    const timeframe = node.attributes['data-timeframe'].value;
    const currentWeekStart = moment(getDataFromDOM('week-start'), 'YYYYMMDD');
    let weekStart;
    let weekEnd;

    if (timeframe === EventTimeframes.NEXT) {
      weekStart = currentWeekStart.clone().add('7', 'days');
      weekEnd = weekStart.clone().add('6', 'days');
    }

    if (timeframe === EventTimeframes.PREVIOUS) {
      weekStart = currentWeekStart.clone().subtract('7', 'days');
      weekEnd = weekStart.clone().add('6', 'days');
    }

    return changeWeek({
      weekStart,
      weekEnd,
    });
  };

  const changeWeekFromDatepicker = weekStart => changeWeek({
    weekStart,
    weekEnd: weekStart.clone().add('6', 'days'),
  });

  const init = async () => {
    if (document.body.classList.contains('page-template-template-whats-on')) {
      datepicker('#datepicker', {
        disabler: date => includes([0, 2, 3, 4, 5, 6], date.getDay()),
        onSelect: (instance, date) => {
          changeWeekFromDatepicker(moment(date));
        },
      });

      setLoading(true);

      event = new Events({
        weekStart: getDataFromDOM('week-start'),
        weekEnd: getDataFromDOM('week-end'),
      });

      await event.init();

      setLoading(false);

      document
        .querySelectorAll('span[data-control="arrow"]')
        .forEach((controlNode) => {
          controlNode.addEventListener('click', () => {
            changeWeekFromTimeframe(controlNode);
          });
        });

      document
        .querySelectorAll('.eventTag')
        .forEach((controlNode) => {
          controlNode.addEventListener('click', () => {
            changeCategory(controlNode);
          });
        });
    }
  };

  return {
    init,
  };
})();
